<template>
  <div id="app">
    <app-loader/>
    <!--    <navigation/>-->
    <div
        :data-route='$route.name ? $route.name.replace(/(?:^|\.?)([A-Z])/g, (x,y) => "-" + y.toLowerCase()).replace(/^\-/, "") : ""'>
      <router-view/>
    </div>
    <active-selections/>
  </div>
</template>

<script>

import {mapGetters, mapActions} from "vuex";

export default {

  name: 'App',

  data: () => {
    return {
      confirmWindowEvent: true
    }
  },

  computed: {

    ...mapGetters({
      eventType: "getEventType"
    })

  },

  metaInfo() {
    return {
      title: "Event Configurator",
      meta: [
        {name: 'description', content: 'Event Configurator'},
        {property: 'og:title', content: "Event Configurator"},
        {property: 'og:site_name', content: window.location.origin},
        {property: 'og:type', content: 'website'},
        {name: 'robots', content: 'index,follow'}
      ]
    }
  },

  created() {
    this.createdComponent();
  },

  methods: {
    ...mapActions(["updateHidePrice"]),
    
    createdComponent() {

      this.confirmWindowClose();
      this.startConfiguratorFromLandingPage();
    },

    confirmWindowClose() {
      if (this.confirmWindowEvent) {
        window.addEventListener("beforeunload", (e) => {

          let confirmationMessage = "\o/";

          (e || window.event).returnValue = confirmationMessage; //Gecko + IE
          return confirmationMessage;                            //Webkit, Safari, Chrome
        });
      }
    },

    startConfiguratorFromLandingPage() {
      this.updateHidePrice(typeof HIDE_PRICE !== 'undefined' ? HIDE_PRICE : 0);
      // redirect to LandingPage if the route is not LandingPage and eventType has no title
      if (this.$route.name !== "LandingPage" && !this.eventType.title) {
        this.$router.push({name: "LandingPage"});
      }
    }
  }
}
</script>

<style lang="scss">

$image-path: '~@/../mdb/mdbvue/img';
@import '~@/../mdb/mdbvue/scss/mdb-free.scss';

body{
  color: var(--widget_font_color);
}

a{
  color: var(--widget_link_color);
}

#app{
  min-height: 640px;
}

</style>



// WEBPACK FOOTER //
// src/App.vue